import { createSelector } from 'reselect';
import get from 'lodash/get';
import { SCOPE } from './types';

const selector = state => get(state, SCOPE);

export default selector;

export const listSelector = createSelector(
  selector,
  (store) => {
    const list = get(store, 'response', []);
    return (list || []).map((item) => {
      let { dashboardTypeId } = item;
      if (dashboardTypeId === undefined) {
        dashboardTypeId = item.dashboardType.id;
      }

      return { ...item, dashboardTypeId };
    });
  },
);

export const listLoaderSelector = createSelector(
  selector,
  store => get(store, 'isFetching', false),
);
